import moment from 'moment';

import { useQueryFilters } from 'hooks';
import { OrderFilters } from 'types';

export const useOrderQueryFilters = (
  initialFilters?: Partial<OrderFilters>,
) => {
  useQueryFilters<OrderFilters>({
    from: moment().subtract(1, 'w').startOf('d').toISOString(),
    ...initialFilters,
  });
};
